<template>
  <div class="law-enforcement-enquiry" id="law-enforcement-enquiry">
    <div class="title">
      {{ translateTitle("MASKEX LEGAL ENFORCEMENT ENQUIRY") }}
    </div>
    <div class="content">
      {{
        translateTitle(
          "Please NOTE that you must be a Legal Enforcement Agent or a Government Official with the official capacity to gather evidence, to make this enquiry from MaskEX."
        )
      }}
    </div>
    <div class="detail">
      {{
        translateTitle(
          "通过访问 MaskEX 查询门户，您在此声明您是执法人员或政府官员的授权人，有权以官方身份向 MaskEX 进行查询。请您了解，如果您提出未经授权的请求，您可能会受到起诉。"
        )
      }}
      <!-- <a
        target="_blank"
        href="https://maskex.zendesk.com/hc/en-us/articles/8281252617617-MaskEX-Guideline-for-Law-Enforcements"
        >{{ translateTitle("（MASKEX：執法指南）。") }}</a
      > -->
      <div style="margin-top: 20px">
        {{
          translateTitle(
            "如您想发起执法请求,请将以下信息发送至Mask官网司法协助邮箱:"
          )
        }}
        <a href="mailto:legal@maskex.com">legal@maskex.com</a>
      </div>
      <div>{{ translateTitle("内容：") }}</div>
      <ul class="email-items">
        <li>{{ translateTitle("电子邮箱") }}</li>
        <li>{{ translateTitle("机构名称（例如：FBI、SEC）") }}</li>
        <li>{{ translateTitle("机构官方电子邮箱地址") }}</li>
        <li>{{ translateTitle("机构联系电话") }}</li>
        <li>{{ translateTitle("机构网站（如适用）") }}</li>
        <li>{{ translateTitle("国家 | 司法管辖区") }}</li>
        <li>
          {{ translateTitle("调查官员（职级、姓名、电子邮箱、联系电话）") }}
        </li>
        <li>
          {{
            translateTitle(
              "请附上您的官方身份证明文件，例如徽章或身份证，以验证您作为执法人员的身份和资质。对于非英文的身份证明文件，请您安排所在国认可的公证人对文件进行公证。"
            )
          }}
        </li>
        <li>
          {{
            translateTitle(
              "请附上正式的支持性文件（例如法院命令、搜查令等）。对于非英文的支持性文件，请您安排所在国认可的公证人对文件进行公证。"
            )
          }}
        </li>
        <li>
          {{ translateTitle("法律依据（例如：盗窃、欺诈等）") }}
        </li>
        <li>
          {{ translateTitle("受害人信息（如适用）") }}
        </li>
        <li>
          {{ translateTitle("背景事实") }}
        </li>
        <li>
          {{
            translateTitle(
              "关键信息（例如：交易哈希 TXID、钱包地址、备注、其他标识符）"
            )
          }}
        </li>
        <li>
          {{ translateTitle("您向 MaskEX 请求提供哪些信息？") }}
        </li>
      </ul>
      <div style="margin-top: 10px">
        {{
          translateTitle(
            "注：由于官网升级近期执法邮箱有修改，如未收到回复的邮件请您在再次发送请求，谢谢！"
          )
        }}
      </div>
    </div>

    <div class="bten">
      <!-- <el-checkbox v-model="checked" :fill="'#15beb4'">{{
        translateTitle("I have read and agree to this disclaimer")
      }}</el-checkbox> -->
    </div>
    <div class="btn">
      <!-- <el-button
        :class="!checked ? 'no' : 'on'"
        @click="pathJump"
        :disabled="!checked"
        type="info"
        round
        >{{ translateTitle("Begin Enquiry") }}</el-button
      > -->
    </div>
    <div></div>
  </div>
</template>
<script>
import { translateTitle } from "@/assets/js/i18n";
import commonMixin from "@/components/common/commonMixin.vue";
export default {
  data() {
    return {
      checked: false,
    };
  },
  mixins: [commonMixin],
  methods: {
    pathJump() {
      window.open("https://forms.gle/kBrehoX1Y2wiuRpC8");
    },
  },
};
</script>

<style lang="scss">
.email-items {
  list-style: disc;
  margin-left: 18px;
  > li {
    list-style: disc;
  }
}
.el-scrollbar__view {
  background: #fff;
}
#law-enforcement-enquiry {
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #15beb4 !important;
    border-color: #15beb4 !important;
  }
  .el-button--info.on {
    background-color: #15beb4;
    border-color: #15beb4;
  }
  .el-button--info.no {
    background-color: #d6d6d6;
    border-color: #d6d6d6;
  }
}
.law-enforcement-enquiry {
  width: 800px;
  margin: 0 auto;
  // background-color: #fff;
  .title {
    font-size: 38px;
    margin-top: 100px;
    font-weight: bold;
    color: #15192a;
  }
  .content {
    margin-top: 30px;
    font-size: 18px;
    color: #15192a;
  }
  .detail {
    a {
      color: #1f73b7;
    }
    margin-top: 35px;
    padding: 23px 34px;
    font-size: 16px;
    // font-family: DIN;
    line-height: 30px;
    color: #15192a;
    background-color: #f8f8f8;
  }
  .bten {
    text-align: center;
    margin-top: 50px;
    font-size: 14px;
    color: #333;
  }
  .btn {
    margin-top: 35px;
    text-align: center;
    margin-bottom: 35px;
    // padding
    span {
      padding: 5px 15px;
    }
    //     width: 160px;
    //     height: 48px;
    //     display: inline-block;
    //     line-height: 48px;
    //     color: #fff;
    //     cursor: pointer;
    //     border-radius: 50px;
    //     background-color: #15beb4;
    //     margin-top: 35px;
    // }
  }
}
</style>
